import CoursewareItemProvider from '../coursewareItem/CoursewareItemProvider';

export default class PluginServices {
  constructor({ id }) {
    this.id = id;
  }

  async getPlugin(id) {
    const courseware = await CoursewareItemProvider.getWalkableData(id || this.id);
    if (courseware && courseware.plugin) {
      const { entryPoints, manifest } = courseware.plugin;

      const data = {
        id: manifest.pluginId,
        name: manifest.name,
        description: manifest.description,
        version: manifest.version,
        componentId: id || this.id,
        configurationSchema: manifest.configurationSchema,
        entryPoints,
      };
      return data;
    }
    return null;
  }

  static build(args) {
    return new PluginServices(args);
  }
}
